import DataTable, { createTheme } from 'react-data-table-component';

export const phypalDataTableCustomStyles = {
  headCells: {
    style: {
      fontSize: '14px',
      color: '#67757c',
      fontWeight: 400,
      overflowX: 'visible',
    },
  },
  rows: {
    style: {
      fontSize: '14px',
      color: '#000',
      padding: '10px 0px',
      '&:not(:last-of-type)': {
        borderBottom: 'none',
      },
    },
  },
  cells: {
    style: {
      fontWeight: 700,
    },
  },
  contextMenu: {
    style: {
      fontWeight: 700,
    },
  },
};
